import React, { useMemo } from 'react';
import { SubSectionText } from '../../shared-styled/blocks/detailedPageBlocks';

const SubSectionTextParsed = ({ html }) => {
  const content = useMemo(
    () =>
      Array.isArray(html)
        ? html.map((subsection) => subsection.value).join('')
        : html,
    [html],
  );

  return content ? <SubSectionText html={content} /> : null;
};

export default SubSectionTextParsed;
